var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('batch-add-card',{attrs:{"config":_vm.edit},on:{"success":_vm.updateData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }